import type { FormControlProps } from '../form-control/form-control';
import { FormControl } from '../form-control/form-control';

export interface RadioButtonProps
  extends Omit<FormControlProps, 'children' | 'type' | 'value'> {
  value: string;
}

const TEST_IDS = {
  OVERLAY_SVG: 'radio-button-overlay-svg',
};

export const RadioButton = ({
  id,
  onChange,
  label,
  name,
  defaultChecked = false,
  'data-testid': testId,
  disabled = false,
  value,
}: RadioButtonProps) => {
  return (
    <FormControl
      id={id}
      name={name}
      onChange={onChange}
      label={label}
      defaultChecked={defaultChecked}
      disabled={disabled}
      type="radio"
      value={value}
      data-testid={testId}
    >
      <svg
        data-testid={TEST_IDS.OVERLAY_SVG}
        width="10"
        height="10"
        viewBox="0 0 10 10"
      >
        <path d="M0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5Z" />
      </svg>
    </FormControl>
  );
};
